// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1bsb1lit{width:10pc}\n._1bsb1wqb{width:60px}\n._1bsb53f4{width:75pt}", ""]);
// Exports
module.exports = exports;
